import { Checkbox } from '@ethsign/ui';
import { useState, useEffect, useMemo } from 'react';
import { ENVS } from '@/constants';
import { Drawer, DrawerContent } from './Drawer.tsx';
import { useParams } from 'react-router-dom';
import { GradientButton } from '@/components/GradientButton.tsx';
import { useContainerStore } from '@/hooks/useGlobalStore';
import { cn } from '@/utils/tailwind.ts';

const flagPrefix = 'WELCOME_MODAL_SHOWED';

export const WelcomeModal = ({ flag }: { flag: string }) => {
  const params = useParams();
  const CHECK_FLAG = `${flagPrefix}_${flag}`;
  const [welcomeModalVisible, setWelcomeModalVisible] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const { container } = useContainerStore();

  const terms = useMemo(() => {
    const terms = ENVS.TERM_OF_USE;

    return terms;
  }, [params]);

  useEffect(() => {
    const welcomeModalShowed = localStorage.getItem(CHECK_FLAG);
    if (welcomeModalShowed === 'true') return;
    setWelcomeModalVisible(true);
  }, []);

  const onEnterButtonClick = () => {
    setWelcomeModalVisible(false);
    localStorage.setItem(CHECK_FLAG, 'true');
  };

  return (
    <Drawer open={welcomeModalVisible} onOpenChange={setWelcomeModalVisible} container={container}>
      <DrawerContent className={cn('bg-card', container ? 'absolute' : '')}>
        <div className="py-6 px-4">
          <div className="text-xl font-bold text-[#EEE]">Welcome!</div>

          <p className="text-xs font-normal text-[#EEE] mt-4">
            TokenTable claims portal is provided on an AS-IS basis as a portal to interface. To use the claims portal,
            you must first read and accept the Terms of Use set forth below.
          </p>

          <div
            className="flex items-center my-4 space-x-2 cursor-pointer"
            onClick={() => {
              setTermsChecked((old) => !old);
            }}
          >
            <Checkbox checked={termsChecked} className="border-gray-300 bg-white" />

            <span className="text-gray-400 text-xs font-normal">
              I have read and agree to be bound by the{' '}
              <a href={terms} target={'_blank'}>
                Terms of Use
              </a>
            </span>
          </div>

          <GradientButton disabled={!termsChecked} onClick={onEnterButtonClick} className={'w-full'}>
            Next
          </GradientButton>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
